// extracted by mini-css-extract-plugin
export default {"root":"gUBhE5NT_BHF_jNZyrmw","link":"gnZ8GdWqjaDBbuCrMIFE","icon":"X71EkcgQvK7udg6GNaxD"};